import { Image } from '@heroui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faceImages = {
  'WB-0-OFF.png': `/painfaces/WB-0-OFF.png`,
  'WB-0-ON.png': `/painfaces/WB-0-ON.png`,
  'WB-2-OFF.png': `/painfaces/WB-2-OFF.png`,
  'WB-2-ON.png': `/painfaces/WB-2-ON.png`,
  'WB-4-OFF.png': `/painfaces/WB-4-OFF.png`,
  'WB-4-ON.png': `/painfaces/WB-4-ON.png`,
  'WB-6-OFF.png': `/painfaces/WB-6-OFF.png`,
  'WB-6-ON.png': `/painfaces/WB-6-ON.png`,
  'WB-8-OFF.png': `/painfaces/WB-8-OFF.png`,
  'WB-8-ON.png': `/painfaces/WB-8-ON.png`,
  'WB-10-OFF.png': `/painfaces/WB-10-OFF.png`,
  'WB-10-ON.png': `/painfaces/WB-10-ON.png`,
};

export function FaceScale({ sendAnswer, answerHistory }) {
  const { t } = useTranslation('survey');
  const [answer, setAnswer] = useState(answerHistory);

  const faceScale = [
    { value: 0, legend: t('facescale.value_0') },
    { value: 2, legend: t('facescale.value_1') },
    { value: 4, legend: t('facescale.value_2') },
    { value: 6, legend: t('facescale.value_3') },
    { value: 8, legend: t('facescale.value_4') },
    { value: 10, legend: t('facescale.value_5') },
  ];

  const handleClick = (value) => {
    setAnswer(value / 2);
    sendAnswer(value / 2);
  };

  return (
    <>
      <div className="flex justify-center">
        <div className="bg-background inline-flex rounded shadow w-full">
          {faceScale.map((face) => (
            <div key={face.value} className="flex justify-center">
              <button onClick={() => handleClick(face.value)}>
                <div className="flex justify-center">
                  {face.value === answer * 2 ? (
                    <Image
                      alt={`${face.value}: ${face.legend}`}
                      src={faceImages[`WB-${face.value}-ON.png`]}
                      disableSkeleton
                    />
                  ) : (
                    <Image
                      alt={`${face.value}: ${face.legend}`}
                      src={faceImages[`WB-${face.value}-OFF.png`]}
                      disableSkeleton
                    />
                  )}
                </div>
                <p>{face.value}</p>
                <p className="text-sm">{face.legend}</p>
              </button>
            </div>
          ))}
        </div>
      </div>
      {answer !== undefined && (
        <div className="flex justify-center p-4">
          <div className="flex flex-col items-center">
            <img
              alt={`${t('common.text.selection')}: ${faceScale[answer].legend}`}
              src={faceImages[`WB-${answer * 2}-ON.png`]}
            />
            <p className="font-bold p-4 pb-8 text-lg">
              {faceScale[answer].legend}
            </p>
          </div>
        </div>
      )}
    </>
  );
}
